package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.businesspartner.bpcrmservice2.contract.model.ContractDetails
import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.Life
import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.life.EndowmentInsurance
import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.life.PensionInsurance
import de.oevbs.businesspartner.bpcrmservice2.contract.model.lineofbusiness.life.TermLifeInsurance
import de.oevbs.kunde.kundenportal2.components.detailsGrid
import de.oevbs.kunde.kundenportal2.components.detailsGridEntry
import de.oevbs.kunde.kundenportal2.components.paragraph
import de.oevbs.kunde.kundenportal2.services.contract.detailsSection
import de.oevbs.kunde.kundenportal2.services.contract.toEuro
import de.oevbs.sfa.data.time.toLocalizedString
import dev.fritz2.core.RenderContext


/**
 * Vertragsdetails der Sparte Leben
 * Abhängig der `riskData` aus [life] heraus wird das UI aufgebaut
 *
 * @param details beinhaltet die generellen Informationen
 * @param life beinhaltet die Sparten spezifischen Informationen
 */
fun RenderContext.contractDetailsLife(details: ContractDetails, life: Life) {
    detailsSection("Versicherte Leistungen") {
        detailsGrid {
            detailsGridEntry("Tarif", life.riskData?.tariffId)
            detailsGridEntry("Tarifvariante", life.riskData?.tariffVariant)
            detailsGridEntry("Beginn der Versicherung", details.general.begin?.toLocalizedString())
            detailsGridEntry("Ablauf der Versicherung", details.general.end?.toLocalizedString())
            detailsGridEntry("Ablauf der Beitragszahlung", life.riskData?.paymentExpiryDate?.toLocalizedString())
            when (life.riskData) {
                is EndowmentInsurance -> {
                    val riskData = life.riskData as EndowmentInsurance
                    detailsGridEntry("Garantierte Todesfallleistung", riskData.sumDeath.toEuro())
                    detailsGridEntry("Garantierte Erlebensfallleistung", riskData.sumAlive.toEuro())
                }

                is PensionInsurance -> {
                    val riskData = life.riskData as PensionInsurance
                    detailsGridEntry("Garantierte Jahresrente", riskData.pensionPerYear.toEuro())
                    detailsGridEntry("Garantierte Kapitalabfindung", riskData.monetaryCompensation.toEuro())
                    detailsGridEntry("Überschussverwendung Rentenbezug", riskData.surplusUsagePension)
                }

                is TermLifeInsurance -> {
                    val riskData = life.riskData as TermLifeInsurance
                    detailsGridEntry("Garantierte Todesfallleistung", riskData.sumDeath.toEuro())
                    detailsGridEntry("Überschussverwendung", riskData.surplusUsageSystem)
                }

                else -> {}
            }
            detailsGridEntry("Dynamik", life.riskData?.dynamic?.id)
            detailsGridEntry("Bezugsrecht im Erlebensfall", life.beneficiary2PartnerName)
            detailsGridEntry("Bezugsrecht im Todesfall", life.beneficiary1PartnerName)
        }
        paragraph {
            p("mt-4") {
                +"Informationen zu möglichen Zusatzversicherungen entnehmen Sie Ihrem Versicherungsschein."
            }
        }
    }
}
